module.exports = __webpack_public_path__ + "img/earth.fb53c963.jpg";